<div class="container-loader" *ngIf="isBusy">
  <ngx-loading [show]="isBusy" [config]="loaderConfig"></ngx-loading>
</div>
<ng-container *ngIf="embedLink">
    <iframe width="100%" height="100%" [src]="embedLink | safe" [ngStyle]="{'border':'none'}" allowfullscreen="true"></iframe>
</ng-container>